<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_bucket") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<div class="xs-12 p-15">
				<!-- Form -->
				<core-form-input
					componentName="j-base-input-text"
					id="bucketName"
					name="bucketName"
					label="Name"
					v-model="form.name"
					class="pl2"
				/>
				<!-- Buttons -->
				<div class="mt6">
					<j-button
						:isLoading="isLoading"
						@click="handleSubmit"
						v-if="form.name"
						>{{ $t("create") }}</j-button
					>
				</div>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseSelect from "@/components/JBaseSelect/"
import JButton from "@/components/JButton/"
import CoreFormInput from "@/modules/core/components/CoreFormInput.vue"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import get from "lodash.get"

export default {
	components: {
		JCard,
		JBaseSelect,
		JButton,
		CoreFormInput,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data() {
		return {
			isLoading: false,

			form: {
				name: ""
			}
		}
	},

	methods: {
		async handleSubmit() {
			const query = gql``

			this.isLoading = true
			const res = await api({
				query,
				variables: {}
			})
			this.isLoading = false

			// Don't check errors, just redirect to detail page
			this.$router.push({
				name: "FileSystemDetail",
				params: { id: res?.data?.apiCall?.createdStatus?.id } // what shoud lbe apiCall here ??
			})
		}
	},

	created() {}
}
</script>
